import { NgModule } from '@angular/core';
import { provideConfig } from '@spartacus/core';
import { AtgProductFeatureSpecsRootModule } from 'src/app/atg/atg-product-feature-specs/root/atg-product-feature-specs-root.module';
import { ATG_PRODUCT_FEATURE_SPECS_FEATURE } from 'src/app/atg/atg-product-feature-specs/root/feature-name';

@NgModule({
  imports: [AtgProductFeatureSpecsRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [ATG_PRODUCT_FEATURE_SPECS_FEATURE]: {
          module: () =>
            import('src/app/atg/atg-product-feature-specs/atg-product-feature-specs.module').then(
              (m) => m.AtgProductFeatureSpecsModule
            ),
        },
      },
    }),
  ],
})
export class AtgProductFeatureSpecsFeatureModule {}
